import { useReactFlow, addEdge } from '@xyflow/react';

export function useTrashNode() {
  const { setNodes, setEdges, getNodes } = useReactFlow();

  /**
   * Deletes a node by its id, reconnecting predecessors to successors,
   * removing any end node if it becomes orphaned, and preventing event propagation
   * so sidebars/dialogs don't open.
   */
  return (e, id) => {
    // Prevent parent handlers (e.g., opening sidebars) from running
    e.preventDefault();
    e.stopPropagation();

    // Determine if end node will be removed after this deletion
    const currentNodes = getNodes();
    const remainingNodes = currentNodes.filter(n => n.id !== id);
    const nonBegin = remainingNodes.filter(
      n => n.type !== 'begin' && n.type !== 'end'
    );
    const endToRemove =
      nonBegin.length === 0
        ? remainingNodes.find(n => n.type === 'end')
        : undefined;

    // Reconnect edges: find predecessors and successors then remove edges to the deleted node
    setEdges(eds => {
      // const predecessors = eds.filter((edge) => edge.target === id).map((edge) => edge.source);
      // const successors = eds.filter((edge) => edge.source === id).map((edge) => edge.target);

      // remove edges touching the deleted node and any edges to a soon-to-be-removed end node
      let next = eds.filter(
        edge =>
          edge.source !== id &&
          edge.target !== id &&
          edge.source !== endToRemove?.id &&
          edge.target !== endToRemove?.id
      );

      // predecessors.forEach((src) => {
      //   successors.forEach((tgt) => {
      //     // If the successor is the end node we'll remove, skip creating this connection
      //     if (tgt === endToRemove?.id) return;
      //     if (src && tgt && src !== tgt) {
      //       const exists = next.some((edge) => edge.source === src && edge.target === tgt);
      //       if (!exists) {
      //         next = addEdge({ id: `e-${src}-${tgt}`, source: src, target: tgt, type: "removableEdge", animated: true }, next);
      //       }
      //     }
      //   });
      // });

      return next;
    });

    // Remove the node (and remove end node if required)
    setNodes(nds => {
      let next = nds.filter(n => n.id !== id);
      if (endToRemove) {
        next = next.filter(n => n.id !== endToRemove.id);
      }

      // Ensure begin exists
      const hasBegin = next.some(n => n.type === 'begin');
      if (!hasBegin) {
        next = [
          {
            id: 'begin-1',
            type: 'begin',
            position: { x: 0, y: 43 },
            data: {}
          },
          ...next
        ];
      }

      return next;
    });
  };
}
